import { HorizontalSpacer, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPurposeSwap extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelPurposeSwap1: Label;
    labelPurposeSwap2: Label;
    textOrderId: Textbox;
}
